/**
 * Shared role predicates for the web admin.
 *
 * Clerk serialises org roles as "org:admin"; the dev/mock bypass uses the bare
 * "admin". `isAdminOrgRole` accepts both so admin-only affordances resolve in
 * every environment. This mirrors the backend NormalizeRole posture (only an
 * admin passes) — the server is the real boundary (issue #906); this predicate
 * is UX/defense-in-depth so non-admins never see or reach analytics/finance
 * surfaces.
 */
export function isAdminOrgRole(orgRole?: string | null): boolean {
  return orgRole === 'admin' || orgRole === 'org:admin';
}
